<template>
  <div class="popup">
    <div class="close" @click="close"><ios-close-icon /></div>
    <div class="row m-0 h-100 w-100 justify-content-center align-items-center" @click.self="close">
      <div class="col-12 col-sm-11 col-md-9 col-lg-7 col-xl-6">
        <div class="popup_inner white_bg p-3 p-md-5">
          <div class="row m-0 pb-3 mb-3 border-bottom">
            <div class="col-12 p-0">
              <h4 class="mb-0">Delete Trustee</h4>
            </div>
          </div>
          <div class="row m-0 pb-3 mb-3">
            <div class="col-12 p-0">
              Are you sure you want to delete <b>{{trustee.firstname}} {{trustee.lastname}}</b>?
            </div>
          </div>
          <div class="row m-0 justify-content-end align-items-center mt-4">
            <div class="col-6 col-sm-4 pe-0">
              <button class="btn btn-secondary w-100" @click="close">Cancel</button>
            </div>
            <div class="col-6 col-sm-4 pe-0">
              <button class="btn btn-primary w-100" @click="remove">Delete</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
// @ is an alias to /src
export default {
  name: 'deleteTrusteePopup',
  props: ['trustee'],
  methods: {
    ...mapActions(['deleteTrustee', 'deleteTrustor']),
    close () {
      this.$emit('close')
    },
    remove () {
      this.deleteTrustee(this.trustee.id)
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.popup {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 999;
}
.popup_inner {
  max-height: 80vh;
  overflow-y: auto;
}
.close {
  color: #fff;
  opacity: 1;
  cursor: pointer;
  position: absolute;
  right: 0;
}
</style>
